/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'yue': {
    width: 128,
    height: 128,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M866.304 291.84H209.92v-.512c-17.408-2.56-30.72-17.408-30.72-35.328s13.312-32.768 30.72-35.328v-.512H691.2c11.264 0 20.48-9.216 20.48-20.48s-9.216-20.48-20.48-20.48H209.92v.512c-36.352 2.048-66.048 30.208-70.656 66.048-.512 1.536-1.024 3.584-1.024 5.12V819.2c0 11.264 9.216 20.48 20.48 20.48h706.56c11.264 0 20.48-9.216 20.48-20.48V311.296c0-10.752-8.704-19.456-19.456-19.456zM844.8 337.92V768c0 11.264-9.216 30.72-20.48 30.72H199.68c-11.264 0-20.48-9.216-20.48-20.48V323.584c9.216 5.12 19.456 8.192 30.72 8.704v.512H844.8v5.12z"/><path pid="1" d="M701.44 732.16H322.56c-11.264 0-20.48-9.216-20.48-20.48s9.216-20.48 20.48-20.48h378.88c11.264 0 20.48 9.216 20.48 20.48s-9.216 20.48-20.48 20.48z"/>'
  }
})
